import { createStore, createLogger } from 'vuex'
import Score from './modules/Score'

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  modules: {
    Score
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
